import { render, staticRenderFns } from "./sisBoxColumn.vue?vue&type=template&id=92115570&lang=pug&"
import script from "./sisBoxColumn.vue?vue&type=script&lang=js&"
export * from "./sisBoxColumn.vue?vue&type=script&lang=js&"
import style0 from "./sisBoxColumn.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports